import api from '../..'

const resetCourse = (userId: number, courseId: number) => {
  return api.get(`administration/users/${userId}/courses/${courseId}/restart`)
}

export default resetCourse
